import React from 'react';

const ProjectAddPage = React.lazy(() => import('pages/Project/ProjectAddPage'));
const ProjectPage = React.lazy(() => import('pages/Project/ProjectPage'));
const ProjectTaskPage = React.lazy(() => import('pages/Project/ProjectTaskPage'));
const ProjectCatalogPage = React.lazy(() => import('pages/Project/ProjectCatalogPage'));
const ProjectTypeConfigurationPage = React.lazy(() => import('pages/Project/ProjectTypeConfigurationPage'));

const projectRoute = [
  { path: '/project/types/:type_code/configuration', exact: true, name: 'Cấu hình loại dự án', function: 'SL_PROJECT_TYPE_VIEW', component: ProjectTypeConfigurationPage },
  { path: '/project', exact: true, name: 'Bán hàng dự án', function: 'SL_PROJECT_VIEW', component: ProjectPage },
  { path: '/project/tasks', exact: true, name: 'Công việc dự án', function: 'SL_PROJECT_EXECUTE', component: ProjectTaskPage },
  { path: '/project/catalogs', exact: true, name: 'Danh mục dự án', function: 'SL_PROJECT_MASTER_DATA', component: ProjectCatalogPage },
  { path: '/project/catalogs/:catalog_key', exact: true, name: 'Khai báo danh mục dự án', function: 'SL_PROJECT_MASTER_DATA', component: ProjectCatalogPage },
  { path: '/task-of-project', exact: true, name: 'Công việc dự án', function: 'SL_PROJECT_EXECUTE', component: ProjectTaskPage },
  { path: '/project/add', exact: true, name: 'Thêm dự án', function: 'SL_PROJECT_ADD', component: ProjectAddPage },
  { path: '/project/detail/:project_id', exact: true, name: 'Chi tiết dự án', function: 'SL_PROJECT_VIEW', component: ProjectAddPage },
  { path: '/project/edit/:project_id', exact: true, name: 'Chỉnh sửa dự án', function: 'SL_PROJECT_EDIT', component: ProjectAddPage },
];

export default projectRoute;
